// extracted by mini-css-extract-plugin
module.exports = {"container":"w_c","logo":"w_9","rotation":"w_bb","star2":"w_bc","star1":"w_bd"};